var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-pagination',{attrs:{"layout":"prev, pager, next","total":_vm.total},on:{"current-change":function (e) { return _vm.$emit('change', e); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }